import {NgModule} from '@angular/core';
import {InputNumberComponent} from './input-number.component';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  declarations: [
    InputNumberComponent,
  ],
  exports: [
    InputNumberComponent,
  ]
})
export class InputNumberModule {
}
